import { AppType } from "./AppType";

export enum App {
	Alchemy,
	GreatAlchemy2,
	ColorByNumber,
	Mazes,
	Sudoku,
	// EnglishVocabulary,
}

export interface AppSpec {
	name: string;
	imgSrc: string;
	routePath: string;
	type: AppType;
	playStore: string;
}

export function getAppSpec(type: App): AppSpec {
	switch (type) {
		case App.Alchemy:
			return {
				name: "Alchemy",
				imgSrc: "https://play-lh.googleusercontent.com/NGDW4mIbUdH1eaK_Mq_WoyfmvWQJKNoxwu3GcJ21O1juhfbzT86GoXtMrnUjJPDlP6U=s180-rw",
				routePath: "alchemy",
				type: AppType.FREEMIUM,
				playStore:
					"https://play.google.com/store/apps/details?id=com.mgsoftware.alchemy&hl=pl&gl=US",
			};
		case App.GreatAlchemy2:
			return {
				name: "Great Alchemy 2",
				imgSrc: "https://play-lh.googleusercontent.com/d9KZQSc4OtGTczaks0TSULIw2z0r69tyZcBypi521sc422oqdDO076VfJAzMYLU77w=s180-rw",
				routePath: "great-alchemy-2",
				type: AppType.FREEMIUM,
				playStore:
					"https://play.google.com/store/apps/details?id=com.mgsoftware.greatalchemy2&hl=pl&gl=US",
			};
		case App.ColorByNumber:
			return {
				name: "Color by Number",
				imgSrc: "https://play-lh.googleusercontent.com/pUxz7N3Jb9vLzKNAWPR5psitbwu08q5kPDiJeI3f8CeeNXEHi0qgD6C3aFW83aAPDA=s180-rw",
				routePath: "color-by-number",
				type: AppType.FREEMIUM,
				playStore:
					"https://play.google.com/store/apps/details?id=com.mgsoftware.colorbynumber&hl=pl&gl=US",
			};
		case App.Sudoku:
			return {
				name: "Sudoku - Daily Challenges",
				imgSrc: "https://play-lh.googleusercontent.com/jUAPTGxF8IymOL9rGuFpt4Qai5iYr98uKrG-H6hcx6TzSgDo_N7-9XkTYGOES7CexQTR=s180-rw",
				routePath: "sudoku-daily-challenges",
				type: AppType.FREEMIUM,
				playStore:
					"https://play.google.com/store/apps/details?id=com.mgsoftware.sudoku&hl=pl&gl=US",
			};
		case App.Mazes:
			return {
				name: "Holo Maze",
				imgSrc: "https://play-lh.googleusercontent.com/O_PZ041sBw_uuZPv1BNA7q4ohSELENoYl4F820QdIPyK_pjSGAkvNesmH_fFrrH8GH47=s180-rw",
				routePath: "mazes",
				type: AppType.FREE,
				playStore:
					"https://play.google.com/store/apps/details?id=com.mgsoftware.maze&hl=pl&gl=US",
			};
		// case App.EnglishVocabulary:
		// 	return {
		// 		name: "Angielski - Słownictwo",
		// 		imgSrc: "https://play-lh.googleusercontent.com/mQ6OJ6qt_HQStxmiHck3NZzk5IQRazSH0Sic_vbxBgVJgDSHxQEhas1QgsZm6Y_CJIA=s180-rw",
		// 		routePath: "angielski-slownictwo",
		// 		type: AppType.FREE,
		// 		playStore:
		// 			"https://play.google.com/store/apps/details?id=com.xshoter26inc.fiszki_angielski",
		// 	};
	}
}
